import App from './App.svelte';

const app = new App({
    target: document.body,
    props: {
        name: 'Veak.me',
        title: 'Veak.me'
    }
});

export default app;